/**
 * @file ヘッダーコンポーネント。事業者ロゴ＋サービスTOPリンクを表示。
 *        ログイン中にCredentialが消失した場合はログイン画面へ強制遷移するガード機能を持つ。
 */
import { providerInfoState } from '@/states/providerInfoState';
import { getCredentials } from '@/utils/cognito';
import { Constants } from '@/utils/constants';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

const Header = () => {
  const router = useRouter();
  const providerInfo = useRecoilValue(providerInfoState);

  useEffect(() => {
    // セッション切れやトークン失効でCredentialが消失してもページにはアクセスできてしまうため、
    // ログイン後の画面でCredentialがない場合は強制的にログイン画面にリダイレクトする
    if (!Constants.PathList.NOT_LOGIN.includes(router.pathname) && getCredentials() === null) {
      router.push('/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.pathname]);

  return (
    <header id='header'>
      <div className='inner'>
        <div className='switch'>
          <h1 className='logo'>
            <a
              href={`${providerInfo.serviceUrl}?nmrint=srvglo_navi_1`}
              className='nurotop'
              rel='noreferrer'
            >
              <span className='label'>{providerInfo.serviceName} TOP</span>
              <span className='indicator' />
            </a>
          </h1>
        </div>
      </div>
    </header>
  );
};

export default Header;
